import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export function CtaSection(): JSX.Element {
  return (
    <section className='py-24 md:py-32'>
      <div className='mx-auto max-w-6xl px-6'>
        <div className='relative overflow-hidden rounded-3xl border border-border bg-foreground px-8 py-20 text-center md:px-16'>
          {/* Decorative elements */}
          <div className='absolute top-0 left-0 h-64 w-64 rounded-full bg-teal/10 blur-3xl' aria-hidden='true' />
          <div className='absolute bottom-0 right-0 h-48 w-48 rounded-full bg-teal/10 blur-3xl' aria-hidden='true' />

          <div className='relative z-10'>
            <h2
              className='text-3xl font-bold tracking-tight text-background md:text-4xl text-balance'
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Eliminate Lease Blind Spots.
            </h2>

            <p className='mx-auto mt-6 max-w-lg text-lg leading-relaxed text-background/70 text-pretty'>
              Centralize monitoring of every lease right and CAM cap.
            </p>

            <div className='mt-10'>
              <Button
                asChild
                size='lg'
                className='rounded-full bg-teal px-10 text-foreground hover:bg-teal-dark text-sm font-semibold h-12'
              >
                <Link to='/requestdemo'>
                  Schedule a Demo
                  <ArrowRight className='ml-1 h-4 w-4' />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
